/** Default-off BUI-294 client capability. Activation requires the paired server flag. */
export function inferredRoutingSuggestionsEnabled(
  env: Record<string, string | undefined> = import.meta.env as unknown as Record<string, string | undefined>,
): boolean {
  return ["1", "true", "yes", "on"].includes(
    env.VITE_MARK_INFERRED_ROUTING_SUGGESTIONS_ENABLED?.trim().toLowerCase() ?? "",
  );
}
